import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import DesktopWindowsIcon from '@mui/icons-material/DesktopWindows';
import { useT } from '../i18n/LanguageContext';

// Shown on small screens where the React Flow canvas isn't usable.
export default function MobileNotice() {
  const theme = useTheme();
  const navigate = useNavigate();
  const t = useT();
  const paper = theme.home?.paper || '#FBF8F4';
  const cyan = theme.home?.cyan || '#1FB6E8';
  return (
    <Box sx={{
      minHeight: '78vh', display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', textAlign: 'center', p: 4, bgcolor: paper,
    }}>
      <DesktopWindowsIcon sx={{ fontSize: 60, color: cyan, mb: 2 }} />
      <Typography variant="h5" sx={{ fontFamily: theme.home?.display, fontWeight: 700, color: theme.home?.ink, mb: 1.5 }}>
        {t('common.mobileNotice.heading')}
      </Typography>
      <Typography sx={{ color: 'text.secondary', maxWidth: 440, mb: 3, lineHeight: 1.6 }}>
        {t('common.mobileNotice.body')}
      </Typography>
      <Button variant="contained" onClick={() => navigate('/')} sx={{ borderRadius: 999, px: 3.5, py: 1.2 }}>
        {t('common.mobileNotice.button')}
      </Button>
    </Box>
  );
}
